import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import List from './list';
import Form from './form';

const Component = () => (
  <Switch>
    <Route path="/devices/add"><Form /></Route>
    <Route path="/devices/edit/:id"><Form /></Route>
    <Route path="/devices"><List /></Route>
    <Redirect to="/devices" />
  </Switch>
);

export default Component;
